import React from 'react'
import featuredImagePng from 'assets/images/featured.png'
import { useTranslation } from 'react-i18next'
import { StyledFeaturedBlock as S } from './FeaturedBlock.styles'

export const FeaturedBlock: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <S.Title>{t`purchase.featuredBlockTitle`}</S.Title>
      <picture>
        <img src={featuredImagePng} alt="body" />
      </picture>
    </>
  )
}
